import Input from './Input';
import InputNumber from './InputNumber';
import Select from './Select';
import PartTypeSelect from './PartTypeSelect/PartTypeSelect';
import Button from './Button';

// Utility functions for rendering form elements
export const renderButton = (label, isFormValid, loading, className) => {
  return <Button label={label} disabled={!isFormValid} loading={loading} className={className} />;
};

export const renderInput = (name, label, type, data, errors, onChange, options = {}) => {
  return (
    <Input name={name} value={data[name] || ''} label={label} type={type} error={errors[name]} onChange={onChange} {...options} />
  );
};

export const renderInputNumber = (name, data, errors, handler, disabled = false) => {
  return <InputNumber name={name} value={data[name] || ''} error={errors[name]} onChange={handler} disabled={disabled} />;
};

export const renderSelect = (name, label, options, data, errors, handler, disableLabel = false) => {
  return (
    <Select
      name={name}
      label={label}
      value={data[name] || ''}
      options={options}
      error={errors[name]}
      onChange={handler}
      disableLabel={disableLabel}
    />
  );
};

export const renderPartTypeSelect = (name, options, data, errors, handler) => {
  return (
    <PartTypeSelect name={name} value={data[name] || ''} options={options} error={errors[name]} onChange={handler} />
  );
};
